import { CampaignTemplates, CampaignTemplateType, getDefaultBlockStructure, } from "@kvix/shared";
import React from "react";
import { AnimatedInstructorsBlock, AnimatedSessionsBlock, campaignBlockList, CommentsBlock, CtaWithFeaturesBlock, CtaWithImgBlock, CtaWithTextBlock, FaqBlock, LoopVideoBlock } from "..";
import { AdminFormPaper } from "../admin";
export class InstructorTemplate {
    constructor() {
        this.defaultStructure = null;
        this.campaignTemplateType = CampaignTemplateType.Instructor;
        this.ConstructDefaultStructure = () => {
            const animatedInstructorsBlockStructure = getDefaultBlockStructure(AnimatedInstructorsBlock);
            const animatedSessionsBlockStructure = getDefaultBlockStructure(AnimatedSessionsBlock);
            const commentsBlockStructure = getDefaultBlockStructure(CommentsBlock);
            const ctaWithFeaturesBlockStructure = getDefaultBlockStructure(CtaWithFeaturesBlock);
            const ctaWithImgBlockStructure = getDefaultBlockStructure(CtaWithImgBlock);
            const ctaWithTextBlockStructure = getDefaultBlockStructure(CtaWithTextBlock);
            const faqBlockStructure = getDefaultBlockStructure(FaqBlock);
            const loopVideoBlockStructure = getDefaultBlockStructure(LoopVideoBlock);
            return {
                name: CampaignTemplates.InstructorTemplate,
                blocks: [
                    ctaWithImgBlockStructure,
                    commentsBlockStructure,
                    ctaWithFeaturesBlockStructure,
                    animatedSessionsBlockStructure,
                    loopVideoBlockStructure,
                    animatedInstructorsBlockStructure,
                    ctaWithTextBlockStructure,
                    faqBlockStructure
                ]
            };
        };
        this.Render = (props) => {
            const { template } = props;
            return (React.createElement(React.Fragment, null, template.blocks.map((block) => {
                const blockType = campaignBlockList[block.name];
                const blockObject = new blockType();
                return (React.createElement(blockObject.Render, { key: block.name, campaignContext: props.campaignContext, block: block }));
            })));
        };
        this.Compose = (props) => {
            const { template } = props;
            return (React.createElement(React.Fragment, null, template.blocks.map((block, index) => {
                const blockType = campaignBlockList[block.name];
                const blockObject = new blockType();
                return (React.createElement(AdminFormPaper, { key: index, title: block.name },
                    React.createElement(blockObject.Compose, { block: block })));
            })));
        };
        this.defaultStructure = this.ConstructDefaultStructure();
    }
}
//# sourceMappingURL=InstructorTemplate.js.map